import React from 'react'
import _ from 'lodash'
import axios from 'axios'
import store from '~/redux/user/store'
import { getToken } from '~/redux/user/tokens'
import './style.css'

class CCAFormNS extends React.Component {
  constructor(p) {
    super(p)
    this.state = {}
  }

  render() {
    return (
      <div className="ccav-ns2 ccav-form">
        <h3 className="title">
          Please enter your phone Number.
        </h3>
        <input
          type="text"
          className="phone-number-input"
          ref={ el => this.phoneInputEl = el }
          placeholder="Phone Number"
          />
        { this.state.error && <div className="error">
          {this.state.error}
        </div> }
        <div
          className={ `button fat cta` + (this.state.processing ? ' processing' : '') }
          onClick={ this.onProceed.bind(this) } >
          Checkout
        </div>
        <p className="warning">** It might take upto an hour to activate the subscription.</p>
      </div>
    )
  }

  onProceed() {
    var plan = this.props.plan
    var user = store.getState().user
    var pd = plan.planDetails[0]

    var phoneNumber = this.phoneInputEl.value

    if (!Number(phoneNumber) || phoneNumber.length !== 10)
      return this.alert('Please enter a 10 digit phone number.')

    this.setState({ processing: true })
    return (
      getToken()
        .then(token =>  axios({
          url: `${window.settings.apiBaseUrl}/ccavenue/ccavenue/rsakey`,
          method: 'POST',
          params: { 'site': window.settings.internalName },
          headers: {
            'Authorization': token,
            'Content-Type': 'application/json'
          },
          data: {
            site: window.settings.internalName,
            userId: user.userId,
            planId: plan.id
          }
        }))
        .then( r => {  return r.data })
        .then( d => this.submitForm(window.settings.apiBaseUrl + '/ccavenue/ccavenue/webhandler', {
          planId: plan.id,

          tid: (new Date()).getTime(),
          order_id: d.orderId,
          merchant_id: d.merchantId,
          amount: pd.recurringPaymentAmount,
          currency: pd.recurringPaymentCurrencyCode,
          billing_email: user.email,
          billing_name: user.name,
          billing_tel: phoneNumber,
          billing_country: 'India',

          merchant_param1: window.settings.internalName,
          merchant_param2: user.userId,
          merchant_param3: plan.id,
          merchant_param4: 'web_browser',
          merchant_param5: btoa(window.location.href),
          redirect_url: window.settings.apiBaseUrl + '/ccavenue/ccavenue/callback',
          cancel_url: window.settings.apiBaseUrl + '/ccavenue/ccavenue/callback'
        }) )
        .catch( e => {
          this.alert(e.message || 'There was an error processing your request')
          console.error(e)
        })
        .then( _ => this.setState({ processing: false }))
    )
  }

  alert(msg) {
    this.setState({ error: msg })
    setTimeout(_ => this.setState({ error: null }), 2000)
  }

  submitForm(url, data) {
    var form = document.createElement('form')
    form.setAttribute('method', 'post')
    form.setAttribute('action', url)

    for(var key in data) {
      if(data.hasOwnProperty(key)) {
        var hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', key);
        hiddenField.setAttribute('value', data[key]);
        form.appendChild(hiddenField);
       }
    }

    document.body.appendChild(form);
    form.submit();
  }
}

export default CCAFormNS
